export default {
  accountService: {
    interval: 500
  },
  priceService: {
    interval: 60000,
    profiles: {
      "FAKE_WETH - FAKE_WBTC": {
        url: "https://api.gdax.com/products/ETH-BTC/ticker",
        bucket: 0.005
      },
      "FAKE_WETH - FAKE_WUSD": {
        url: "https://api.gdax.com/products/ETH-USD/ticker",
        bucket: 50
      },
      "WETH - DAI": {
        url: "https://api.gdax.com/products/ETH-USD/ticker",
        bucket: 50
      }
    }
  },
  auctionService: {
    currencyWETH: {
      // WETH
      symbol: 'WETH',
      kovan: '0xd0a1e359811322d97991e03f863a0c30c2cf029c',
      mainnet: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2'
    },
    currency: {
      // DAI
      symbol: 'DAI',
      kovan: '0xC4375B7De8af5a38a93548eb8453a498222C4fF2',
      mainnet: '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359'
    }
  },
  datesService: {
    interval: 60000
  },
  strikesService: {
    priceCount: 15
  },
  networkService: {
    interval: 500,
    networks: {
      //  '1': 'mainnet',
      '42': 'kovan',
      5777: 'development'
    }

  },
  tokenService: {
    faucets: {
      "FAKE_WETH": true,
      "FAKE_BTC": true
    }
  },
  etherscan: {
    kovan: 'https://kovan.etherscan.io',
    mainnet: 'https://etherscan.io',
    development: 'https://localhost'
  },
  web3: {
    name: 'Optionality D\'app'
  }
}


// WEBPACK FOOTER //
// ./src/api/config.js